import React from "react";
import { LastWarehouseUpdateDetails } from "../LastWarehouseUpdate/LastWarehouseUpdateDetails";

export function DataHistoryLastWarehouseUpdate(props) {
	const dataHistory = props.dataHistory;
	if (!dataHistory || dataHistory.length === 0) {
		return null;
	}
	const { lastUpdate: lastSynced, error: syncErrors } = joinDataHistory(dataHistory);

	const details = {
		last_synced: lastSynced,
		sync_errors: syncErrors,
	};

	return <LastWarehouseUpdateDetails details={details} />;
}

function getTime(date) {
	return date ? new Date(date).getTime() : 0;
}

function joinDataHistory(dataHistory) {
	const latestTime = dataHistory.reduce((a, b) => (Math.max(a, getTime(b.event_time))), 0);
	const nameErrors = dataHistory.filter((sync) => sync.error_message).map((sync) => `${sync.source}: ${sync.error_message}`);
	const errors = nameErrors.join(" | ");
	return { lastUpdate: latestTime, error: errors };
}